import { Grid, MenuItem } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'formik-mui';
import { Locale } from 'helpers/Enums';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';


let NewReporter = () => {
    let { formatMessage } = useIntl();

    return (
        <>
            <Grid item xs={12}>
                <Field
                    component={TextField}
                    name="newReporterUserName"
                    type="email"
                    label={formatMessage({ id: LocalizationIds.Email })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Field
                    component={TextField}
                    name="newReporterFirstName"
                    label={formatMessage({ id: LocalizationIds.Reporter })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Field
                    component={TextField}
                    name="newReporterLastName"
                    label={formatMessage({ id: LocalizationIds.LastName })}
                />
            </Grid>
            <Grid item xs={12}>
                <Field
                    component={TextField}
                    select
                    name="newReporterLanguage"
                    label={formatMessage({ id: LocalizationIds.Language })}
                    size="small"
                >
                    <MenuItem key={Locale.Italian} value={Locale.Italian}>{formatMessage({ id: LocalizationIds.Italian })}</MenuItem>
                    <MenuItem key={Locale.English} value={Locale.English}>{formatMessage({ id: LocalizationIds.English })}</MenuItem>
                </Field>
            </Grid>
        </>
    )
}

export default NewReporter;